import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchQuestionComponent } from './search-question/search-question.component';
import { CarouselModule } from 'primeng/carousel';
import {ButtonModule} from 'primeng/button';
import { SliderModule } from 'primeng/slider';
import { FormsModule } from '@angular/forms';
import { BookingSummaryComponent } from './booking-summary/booking-summary.component';
import { BookAnInspectionComponent } from './book-an-inspection/book-an-inspection.component';
import { XnFormModule } from '../ui-components/xn-form/xn-form.module';
import { TranslateModule } from '@ngx-translate/core';
import { RoomDetailComponent } from './room-detail/room-detail.component';
import { DialogModule } from 'primeng/dialog';
import { XnPipeModule } from '../pipes/xn-pipe.module';
import { BookingDiscountFormComponent } from './booking-discount-form/booking-discount-form.component';
import { TooltipModule } from 'primeng/tooltip';
import { HeaderSearchBarComponent } from './header-search-bar/header-search-bar.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextModule } from 'primeng/inputtext';
import { XnCarouselModule } from '../ui-components/xn-carousel/xn-carousel.module';
import { DropdownModule } from '../ui-components/dropdown/dropdown-module';
import { CalendarModule } from '../ui-components/calendar/calendar-module';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';

@NgModule({
  declarations: [
    SearchQuestionComponent,
    BookingSummaryComponent,
    BookAnInspectionComponent,
    RoomDetailComponent,
    BookingDiscountFormComponent,
    HeaderSearchBarComponent
  ],
  imports: [
    CommonModule,
    CarouselModule,
    ButtonModule,
    FormsModule,
    SliderModule,
    CalendarModule,
    XnFormModule,
    TranslateModule,
    DialogModule,
    XnPipeModule,
    TooltipModule,
    DropdownModule,
    MultiSelectModule,
    InputTextModule,
    XnCarouselModule,
    SelectModule,
    DatePickerModule,
  ],
  exports: [
    SearchQuestionComponent,
    BookingSummaryComponent,
    BookAnInspectionComponent,
    RoomDetailComponent,
    BookingDiscountFormComponent,
    HeaderSearchBarComponent
  ]
})
export class ApartmentsModule { }
